import clsx from 'clsx';
import React from 'react';

type Props = {
  status: 'draft' | 'open' | 'closed' | 'active';
};

const toTitleCase = (s: string): string =>
  s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();

export const StatusBadge = ({ status }: Props) => (
  <div
    className={clsx(
      'flex items-start justify-start w-fit h-fit font-helvetica text-xmd',
      'rounded-[4px] border-[0.5px] border-main p-[4px] px-[9px]',
      status === 'draft' && 'border-dashed',
      status === 'open' && 'animate-[border-pulse_2.5s_ease-in-out_infinite]',
      status === 'active' && 'animate-[border-pulse_2.5s_ease-in-out_infinite]'
    )}
    data-testid="invoice-status-badge"
  >
    <span className="text-xmd text-main">{toTitleCase(status)}</span>
  </div>
);
